import React from 'react';
import { APP_STORE_URL } from '../utils/site';

const AppStoreBadge = ({ className, size = 'default' }) => {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Download Recalls365 on the App Store"
    >
      <img
        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
        alt="Download on the App Store"
        className={`app-store-badge ${size}`}
        loading="lazy"
      />
    </a>
  );
};

export default AppStoreBadge;
